import { Alert } from "@mui/material";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import {
  FacilityForm,
  type Props as FacilityFormProps,
} from "Components/Shared/Merchant/Facilities/FacilityForm";
import { useMerchantFacilityInfo } from "Components/Shared/Merchant/Facilities/hooks/useMerchantFacilityInfo";
import { Resources, useResource } from "Translations/Resources";

type Props = Omit<
  FacilityFormProps,
  | "hasComgateProduct"
  | "hasOrbitLProduct"
  | "hasSoftPosProduct"
  | "isHunterFinanced"
>;

export const FacilityFormInitializer = (props: Props) => {
  const { t } = useResource();
  const {
    hasComgateProduct,
    hasOrbitLProduct,
    hasSoftPosProduct,
    isHunterFinanced,
    isLoading,
    isError,
  } = useMerchantFacilityInfo(props.merchantPublicID);

  if (isLoading) {
    return <CenteredCircularProgress />;
  }

  if (isError) {
    return (
      <Alert severity="error">{t(Resources.Errors.DataLoadingError)}</Alert>
    );
  }

  return (
    <FacilityForm
      {...props}
      hasComgateProduct={hasComgateProduct}
      hasOrbitLProduct={hasOrbitLProduct}
      hasSoftPosProduct={hasSoftPosProduct}
      isHunterFinanced={isHunterFinanced}
    />
  );
};
